import { render, staticRenderFns } from "./dyAlliance.vue?vue&type=template&id=6c3b40d7"
import script from "./dyAlliance.vue?vue&type=script&lang=js"
export * from "./dyAlliance.vue?vue&type=script&lang=js"
import style0 from "./dyAlliance.vue?vue&type=style&index=0&id=6c3b40d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports